import styled from "styled-components";

export const InputElement = styled.input`
  padding: 8px 10px;
  width: 100%;

  font-size: 12px;
  font-weight: 400;
  background-color: white;

  border: 1px solid black;
  border-radius: 4px;

  &:focus,
  &:hover {
    outline: none;
  }

  &:-webkit-autofill {
    background-color: white !important;
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    box-shadow: 0 0 0px 1000px white inset !important;
    -webkit-text-fill-color: black !important; /* Corrige a cor do texto */
  }
`;
